import { Injectable, DOCUMENT, inject, WritableSignal, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class Seo {
  private doc = inject(DOCUMENT);
  private readonly _currentURL: WritableSignal<string> = signal('');
  readonly address = this._currentURL.asReadonly();

  updateCanonical = () => {
    const url = this.doc.URL;
    let canonical = this.doc.querySelector('link[rel="canonical"]');
    canonical?.setAttribute('href', url);
    this._currentURL.set(url);
  }
}
